import React from "react";
import { Link } from "react-router-dom";
import "./Cost.css";
import "../../styleguide.css";
import Toggle from "../Toggle";

function Cost(props) {
  const {
    x1200PxLogo_Icam__20081,
    pleaseAnswerTheFollowingQuestions,
    toggle1Props,
    toggle2Props,
  } = props;

  return (
    <div className="environmental-container">
      <app-header></app-header>

      <div className="environmental-content">
        <h1 className="environmental-title">
          {pleaseAnswerTheFollowingQuestions || "COST ASSESSMENT"}
        </h1>
        
        <div className="section-description">
          <p>
            This assessment will evaluate your organization's cost management practices across several key areas.
            The assessment is divided into two sections to thoroughly evaluate your cost management approach.
            Please respond to all questions to receive a comprehensive evaluation.
          </p>
        </div>

        <div className="assessment-options">
          <Link to="/cost-1" className="assessment-button">
            <span className="button-title">Section 1</span>
            <span className="button-description">Raw Materials and Stock Management</span>
          </Link>
          
          <Link to="/cost-2" className="assessment-button">
            <span className="button-title">Section 2</span>
            <span className="button-description">Market Analysis and Competition</span>
          </Link>
        </div>

        <div className="form-actions">
          <Link to="/home" className="btn-secondary">
            Back to Home
          </Link>
          <Link to="/cost-1" className="btn-primary">
            Start Assessment
          </Link>
        </div>
        
        <div className="toggle-wrapper">
          <Toggle className={toggle1Props.className} buttonSecondaryProps={toggle1Props.buttonSecondaryProps} />
          <Toggle className={toggle2Props.className} buttonSecondaryProps={toggle2Props.buttonSecondaryProps} />
        </div>
      </div>
    </div>
  );
}

export default Cost;
